function temizleParca(value, fallback = 'tum') {
  const raw = String(value ?? '').trim();
  if (!raw) return fallback;
  return raw
    .toLocaleLowerCase('tr-TR')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-_.]/g, '')
    .slice(0, 80) || fallback;
}

export function olusturAksiyonDurumKapsami(drawerKey, entity) {
  const filters = entity?.filters || {};
  const payload = entity?.payload || {};

  const parcalar = [
    `d:${temizleParca(drawerKey, 'genel')}`,
    `w:${temizleParca(filters.window, 'default')}`,
    `y:${temizleParca(filters.surface, 'tum')}`,
    `b:${temizleParca(filters.context, 'tum')}`,
    `s:${temizleParca(filters.segment, 'tum')}`
  ];

  if (payload?.key) parcalar.push(`k:${temizleParca(payload.key)}`);
  if (payload?.expertId) parcalar.push(`u:${temizleParca(payload.expertId)}`);
  if (payload?.segmentKey) parcalar.push(`sg:${temizleParca(payload.segmentKey)}`);

  return {
    drawerKey: temizleParca(drawerKey, 'genel'),
    entityKey: parcalar.join('|')
  };
}

